import React from "react";
import ImageWithBasePath from "../imageWithBasePath";
import "./thumbnailImage.css";

interface ThumbnailImageProps {
  src: string;
  alt: string;
  className?: string;
  overlayContent?: React.ReactNode;
}

/**
 * ThumbnailImage component that maintains a 16:9 aspect ratio
 * across all screen sizes (mobile and desktop).
 */
const ThumbnailImage: React.FC<ThumbnailImageProps> = ({ 
  src, 
  alt, 
  className = "",
  overlayContent 
}) => {
  return (
    <div className={`thumbnail-container ${className}`}>
      <div className="thumbnail-aspect-ratio">
        <ImageWithBasePath
          src={src}
          alt={alt}
          className="thumbnail-image"
        />
        {overlayContent && (
          <div className="thumbnail-overlay">
            {overlayContent}
          </div>
        )}
      </div>
    </div>
  );
};

export default ThumbnailImage;

